<template>
  <div>
    <list row-key="SimulatorId" ref="list" unit="模拟器" :expand-all-row="true" :page="page" :query-params="params"
      :show-checkbox="$permission.canDel()" :show-query="showQuery" :get-data-func="api.list" @reset="reset">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="所属组织">
          <tree-select ref="treeSelect" :props="props" :options="TreeData" :value="params.DpId"
            :clearable="true" :accordion="true" :parentSelect="true" placeholder="请选择"
            @node-select="onTreeSelect($event)" />
        </el-form-item>
        <el-form-item label="备案状态">
          <el-select   v-model="params.RecordStatus" placeholder="请选择状态" clearable>
            <el-option label="未备案" :value="0"></el-option>
            <el-option label="备案中" :value="1"></el-option>
            <el-option label="备案失败" :value="2"></el-option>
            <el-option label="备案通过" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模拟器品牌">
          <el-select v-model="params.SimulatorBrand" clearable>
            <el-option v-for="item in brandList" :key="item.DataName" :value="item.DataName" />
          </el-select>
        </el-form-item>
        <el-form-item label="模拟器类型">
          <el-select v-model="params.SimulatorType" clearable>
            <el-option v-for="item in typeList" :key="item.DataName" :value="item.DataName" />
          </el-select>
        </el-form-item>
        <el-form-item label="模拟器型号">
          <el-select v-model="params.SimulatorModel" clearable>
            <el-option v-for="item in modelList" :key="item.DataName" :value="item.DataName" />
          </el-select>
        </el-form-item>
        <el-form-item label="IMEI/MAC">
          <el-input v-model="params.ImeiMac" placeholder="请填写IMEI/MAC" clearable />
        </el-form-item>
        <el-form-item label="生产厂家">
          <el-select v-model="params.Manufactor" clearable>
            <el-option v-for="item in factorList" :key="item.DataName" :value="item.DataName" />
          </el-select>
        </el-form-item>
        <el-form-item label="模拟器编号">
          <el-input v-model="params.SimulatorNo" placeholder="请填写模拟器编号" clearable />
        </el-form-item>
        <el-form-item label="培训车型">
          <el-select v-model="params.CarTypes" clearable multiple>
            <el-option v-for="item in carTypes" :key="item.DataName" :value="item.DataName" />
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DpName" label="归属机构" min-width="150" />
        <el-table-column prop="SimulatorNo" label="模拟器编号">
          <template slot-scope="{row}">
            <span :style="$permission.canRecord()&&(row.RecordStatus==0||row.RecordStatus==2)?'color:#f11;':''">{{row.SimulatorNo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SimulatorBrand" label="模拟器品牌" />
        <el-table-column prop="SimulatorType" label="模拟器类型" />
        <el-table-column prop="SimulatorModel" label="模拟器型号" />
        <el-table-column prop="DeviceCode" label="终端编码" />
        <el-table-column prop="Sim" label="SIM卡" />
        <el-table-column prop="ImeiMac" label="IMEI/MAC" />
        <el-table-column prop="Manufactor" label="生产厂家" />
        <el-table-column prop="CarTypes" label="培训车型" />
        <el-table-column prop="GpsLng" label="经度" />
        <el-table-column prop="GpsLat" label="纬度" />
        <el-table-column prop="InDate" label="入库日期" min-width="110" v-if="loginInfo.UserType!=1">
          <template slot-scope="{row}">
            {{$commonJs.toDateString(row.InDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="RecordStatus" label="备案状态" width="90" align="center">
          <template slot-scope="{row}">
            <span v-if="row.RecordStatus==0" style="color:#f11;">未备案</span>
            <span v-else-if="row.RecordStatus==1">备案中</span>
            <span v-else-if="row.RecordStatus==2" style="color:#f11;">备案失败</span>
            <span v-else-if="row.RecordStatus==3">备案通过</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
  var loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";
  import treeSelect from "@/components/common/treeSelect";

  export default {
    mixins: [listMixin],
    components: { list, treeSelect },
    data() {
      return {
        api: require("@/api/op/simulator").default,
        basicApi: require("@/api/basic/data").default,
        dpApi: require("@/api/basic/dp").default,
        params: {
          CoopMode: null,
          Status: null,
          DpIdChain: "",
          ImeiMac: "",
        },
        props: {
          value: "DpId",
          label: "DpName",
          children: "children",
        },
        loginInfo,
        TreeData: [],
        brandList: [],//品牌
        typeList: [],//类型
        modelList: [],//型号
        factorList: [],//生产厂家
        carTypes: [],//车型
      };
    },
    beforeMount() {
      this.dpApi.getAuthList({ DpTypes: [2, 3], Status: 3, NoReturnParent: true }).then((res) => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
      });
      this.basicApi.list({ ClassName: "模拟器品牌", Status: 1 }).then(res => {
        this.brandList = res.Data
      });
      this.basicApi.list({ ClassName: "模拟器类型", Status: 1 }).then(res => {
        this.typeList = res.Data
      });
      this.basicApi.list({ ClassName: "模拟器型号", Status: 1 }).then(res => {
        this.modelList = res.Data
      });
      this.basicApi.list({ ClassName: "模拟器厂家", Status: 1 }).then(res => {
        this.factorList = res.Data
      });
      this.basicApi.list({ ClassName: "培训车型", Status: 1 }).then(res => {
        this.carTypes = res.Data
      });
    },
    methods: {
      onTreeSelect(t) {
        if (!t) {
          this.params.DpIdChain = null;
        } else {
          this.params.DpIdChain = t.IdChain;
        }
      },
      onExport() {
        this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
      },
      reset() {
        this.$refs.treeSelect.clearHandle();
      },
      delRange(ids) {
        this.api.delete({ ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
</script>